<form>
  <div class="p-grid p-fluid basic-filter">
    <div class="p-col-12 p-md-12 p-lg-12">
     
      <form-factory class="input input__textarea"
                    [formGroup]="form"
                    [model]="getNote()"
                    (onChange)="change()"></form-factory>
    </div>
  </div>
</form>
